export function CRUDTableHeader({ children }) {
    return (
        <thead>
            <tr>
                {children}
            </tr>
        </thead>
    )
}